export default {"src":"/_next/static/media/logo-square.e01951d5.svg","height":50,"width":60,"blurWidth":0,"blurHeight":0};